// api.js

import axiosInstance from "../axiosInstance";

export const clientConfigService = {
  create: async (obj) => {
    try {
      let response = await axiosInstance.post("/client-config", obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (client_id, limit = 15, skip = 0, key) => {
    try {
      const response = await axiosInstance.get(
        `/client-config?$limit=${limit}&$skip=${skip}&client_id=${client_id}${
          key ? `&key=${key}` : ""
        }`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  edit: async (id, obj) => {
    try {
      let response = await axiosInstance.patch(`/client-config/${id}`, obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/client-config/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  defaultConfigs: async () => {
    let response = await axiosInstance.get("/default-client-config");
    return response.data;
  },
};
